import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * アポイントメントデータ一覧
 *
 * 自分が所持しているアポイントメントの一覧を返す
 */
export class FetchAppointment implements APIRequest<Monitaro.FetchAppointmentResponse> {
  response: Monitaro.FetchAppointmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/appointments`
  }
}

/**
 * スケジュールデータ一覧
 *
 * 自分が所持しているスケジュール（訪問予定/訪問結果）の一覧を返す
 */
export class FetchSchedule implements APIRequest<Monitaro.FetchAppointmentResponse> {
  response: Monitaro.FetchAppointmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/appointments/schedules`
  }
}

/**
 * アポイントメント申請
 *
 * 病院管理者からアポイントの申請を行う
 */
export class PostAppointment implements APIRequest<Monitaro.PostAppointmentResponse> {
  response: Monitaro.PostAppointmentResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.POST
  params: Monitaro.AppointmentRequest
  constructor(params: Monitaro.AppointmentRequest) {
    this.params = params
    this.path = `/appointments`
  }
}

/**
 * アポイントメントデータの取得
 *
 * 指定されたアポイントメントIDのデータを取得する&lt;br&gt;
保有していないアポイントメントIDの場合はステータス404を返す
 */
export class GetAppointment implements APIRequest<Monitaro.GetAppointmentResponse> {
  response: Monitaro.GetAppointmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(appointment: string) {
    this.path = `/appointments/${appointment}`
  }
}

/**
 * アポイントメントデータの更新
 *
 * アポイントメントのデータの更新を行う
 */
export class PutAppointment implements APIRequest<Monitaro.PutAppointmentResponse> {
  response: Monitaro.PutAppointmentResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.PUT
  params: Monitaro.AppointmentRequest
  constructor(appointment: string, params: Monitaro.AppointmentRequest) {
    this.params = params
    this.path = `/appointments/${appointment}`
  }
}

/**
 * アポイントメント削除
 *
 * 指定されたアポイントメントを削除する
 */
export class DeleteAppointment implements APIRequest<Monitaro.DeleteAppointmentResponse> {
  response: Monitaro.DeleteAppointmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  params?: { target?: 'result' | 'schedule' }
  constructor(appointment: string, target?: 'result' | 'schedule') {
    this.path = `/appointments/${appointment}`
    if (target) {
      this.params = { target }
    }
  }
}
